import axios from "axios";
import { API } from "./client";

export async function listFolderSchemas() {
  const res = await axios.get(`${API}/folder-schemas`);
  return res.data;
}

export async function getFolderSchema(schemaId) {
  const res = await axios.get(`${API}/folder-schemas/${schemaId}`);
  return res.data;
}

export async function getFolderSchemaDefaults() {
  const res = await axios.get(`${API}/folder-schemas/defaults`);
  return res.data;
}

export async function setUserDefaultFolderSchema(schemaId) {
  const res = await axios.post(`${API}/folder-schemas/default/user`, { schema_id: schemaId });
  return res.data;
}

export async function createFolderSchema(schema) {
  const res = await axios.post(`${API}/folder-schemas`, schema);
  return res.data;
}

export async function updateFolderSchema(schemaId, schema) {
  const res = await axios.put(`${API}/folder-schemas/${schemaId}`, schema);
  return res.data;
}

export async function deleteFolderSchema(schemaId) {
  const res = await axios.delete(`${API}/folder-schemas/${schemaId}`);
  return res.data;
}

export async function suggestAndPrepareFolderSchema(folderId, projectName) {
  const res = await axios.post(`${API}/folder-schemas/suggest-and-prepare`, {
    folder_id: folderId,
    project_name: projectName || "Imported Project",
  });
  return res.data;
}


export async function chatLayoutAssistant(message, history = []) {
  const res = await axios.post(`${API}/folder-schemas/layout-assistant`, { message, history });
  return res.data;
}
